import React from 'react';

import FlagAT from 'flagkit-web/svgs/AT.svg';
import FlagAU from 'flagkit-web/svgs/AU.svg';
import FlagBE from 'flagkit-web/svgs/BE.svg';
import FlagBG from 'flagkit-web/svgs/BG.svg';
import FlagCA from 'flagkit-web/svgs/CA.svg';
import FlagCY from 'flagkit-web/svgs/CY.svg';
import FlagCZ from 'flagkit-web/svgs/CZ.svg';
import FlagDE from 'flagkit-web/svgs/DE.svg';
import FlagDK from 'flagkit-web/svgs/DK.svg';
import FlagEE from 'flagkit-web/svgs/EE.svg';
import FlagES from 'flagkit-web/svgs/ES.svg';
import FlagEU from 'flagkit-web/svgs/EU.svg';
import FlagFI from 'flagkit-web/svgs/FI.svg';
import FlagFR from 'flagkit-web/svgs/FR.svg';
import FlagGB from 'flagkit-web/svgs/GB.svg';
import FlagGR from 'flagkit-web/svgs/GR.svg';
import FlagHR from 'flagkit-web/svgs/HR.svg';
import FlagHU from 'flagkit-web/svgs/HU.svg';
import FlagIE from 'flagkit-web/svgs/IE.svg';
import FlagIT from 'flagkit-web/svgs/IT.svg';
import FlagLT from 'flagkit-web/svgs/LT.svg';
import FlagLU from 'flagkit-web/svgs/LU.svg';
import FlagLV from 'flagkit-web/svgs/LV.svg';
import FlagMT from 'flagkit-web/svgs/MT.svg';
import FlagMX from 'flagkit-web/svgs/MX.svg';
import FlagNL from 'flagkit-web/svgs/NL.svg';
import FlagPL from 'flagkit-web/svgs/PL.svg';
import FlagPT from 'flagkit-web/svgs/PT.svg';
import FlagRO from 'flagkit-web/svgs/RO.svg';
import FlagSE from 'flagkit-web/svgs/SE.svg';
import FlagSI from 'flagkit-web/svgs/SI.svg';
import FlagSK from 'flagkit-web/svgs/SK.svg';
import FlagUS from 'flagkit-web/svgs/US.svg';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const flags = {
  AT: FlagAT,
  AU: FlagAU,
  BE: FlagBE,
  BG: FlagBG,
  CA: FlagCA,
  CY: FlagCY,
  CZ: FlagCZ,
  DE: FlagDE,
  DK: FlagDK,
  EE: FlagEE,
  ES: FlagES,
  EU: FlagEU,
  FI: FlagFI,
  FR: FlagFR,
  GB: FlagGB,
  GR: FlagGR,
  HR: FlagHR,
  HU: FlagHU,
  IE: FlagIE,
  IT: FlagIT,
  LT: FlagLT,
  LU: FlagLU,
  LV: FlagLV,
  MT: FlagMT,
  NL: FlagNL,
  PL: FlagPL,
  PT: FlagPT,
  RO: FlagRO,
  SE: FlagSE,
  SI: FlagSI,
  SK: FlagSK,
  US: FlagUS,
  MX: FlagMX,
};

const Svg = styled.svg`
  max-width: 100%;
  vertical-align: top;
`;

export default function FlagIcon({ country, width, height, ...props }) {
  const FlagComponent = flags[country];
  return FlagComponent ? (
    <Svg
      as={FlagComponent}
      width={width}
      height={height}
      role="img"
      {...props}
    />
  ) : null;
}

FlagIcon.propTypes = {
  /**
   * Two-letter country code of the flag to render.
   */
  country: PropTypes.oneOf([
    'AT',
    'AU',
    'BE',
    'BG',
    'CA',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'EU',
    'FI',
    'FR',
    'GB',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
    'US',
    'EU',
    'MX',
  ]).isRequired,
  /**
   * Icon height; defaults to scaling with the width.
   */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Icon width; defaults to the natural size of the SVG.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

FlagIcon.defaultProps = {
  height: null,
};
